import { SearchTarget } from '@/types'

export interface BibliographyAuthoritySubjectSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  subject: string
  subjectNo: string
}

export function BibliographyAuthoritySubjectSearchRequestToJSON(
  value: BibliographyAuthoritySubjectSearchRequest
): any {
  return {
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    subject: value.subject !== '' ? value.subject : undefined,
    subject_no: value.subjectNo !== '' ? value.subjectNo : undefined
  }
}
